import { axiosGet, axiosPost } from '../../../../react_axios/Axios';
import {
    headers,
    getInternetConnectionMasterListUrl,
    insertUpdateInternetConnectionMasterUrl,
    deleteInternetConnectionMasterUrl,
    getInternetConnectionServiceItemsUrl,
    insertUpdateInternetConnectionServiceItemsUrl,
    GET_INTERNET_CONNECTION_MASTER_LIST,
    INSERT_UPDATE_INTERNET_CONNECTION_MASTER,
    DELETE_INTERNET_CONNECTION_MASTER,
    GET_INTERNET_CONNECTION_SERVICE_ITEMS,
    INSERT_UPDATE_INTERNET_CONNECTION_SERVICE_ITEMS,
} from '../../../../utils/constants';

// ─── Get contact/bank list (Admin, old master) ───────────────────────────────
export const getInternetConnectionMasterList_action = () => async (dispatch) => {
    try {
        const params = {
            UserID:       JSON.parse(sessionStorage.getItem('loginDataSS')).UserID,
            ExhibitionID: sessionStorage.getItem('sessionExhibitionID'),
        };
        const res = await axiosGet(getInternetConnectionMasterListUrl, params, headers);
        dispatch({ type: GET_INTERNET_CONNECTION_MASTER_LIST, payload: res });
        return Promise.resolve(res);
    } catch (error) {
        return Promise.reject(error);
    }
};

// ─── Insert/Update contact/bank record (Admin, old master) ───────────────────
// ICList: [{ BankName, Branch, Address, AccountNumber, RTGS_IFSC, Name, Phone, Mobile, Fax, Email, Designation }]
export const insertUpdateInternetConnectionMaster_action = (ICList) => async (dispatch) => {
    try {
        const params = {
            UserID:       JSON.parse(sessionStorage.getItem('loginDataSS')).UserID,
            ExhibitionID: sessionStorage.getItem('sessionExhibitionID'),
            ICList,
        };
        const res = await axiosPost(insertUpdateInternetConnectionMasterUrl, params, headers);
        dispatch({ type: INSERT_UPDATE_INTERNET_CONNECTION_MASTER, payload: res });
        return Promise.resolve(res);
    } catch (error) {
        return Promise.reject(error);
    }
};

// ─── Delete contact/bank record (Admin, old master) ──────────────────────────
export const deleteInternetConnectionMaster_action = (InternetConnectionContactPersonID, InternetConnectionBankDetailID) => async (dispatch) => {
    try {
        const params = {
            UserID:                             JSON.parse(sessionStorage.getItem('loginDataSS')).UserID,
            ExhibitionID:                       sessionStorage.getItem('sessionExhibitionID'),
            InternetConnectionContactPersonID,
            InternetConnectionBankDetailID:     InternetConnectionBankDetailID || null,
        };
        const res = await axiosGet(deleteInternetConnectionMasterUrl, params, headers);
        dispatch({ type: DELETE_INTERNET_CONNECTION_MASTER, payload: res });
        return Promise.resolve(res);
    } catch (error) {
        return Promise.reject(error);
    }
};

// ─── Get active service items (Admin, new) ───────────────────────────────────
export const getInternetConnectionServiceItems_action = () => async (dispatch) => {
    try {
        const params = {
            UserID:       JSON.parse(sessionStorage.getItem('loginDataSS')).UserID,
            ExhibitionID: sessionStorage.getItem('sessionExhibitionID'),
        };
        const res = await axiosGet(getInternetConnectionServiceItemsUrl, params, headers);
        dispatch({ type: GET_INTERNET_CONNECTION_SERVICE_ITEMS, payload: res });
        return Promise.resolve(res);
    } catch (error) {
        return Promise.reject(error);
    }
};

// ─── Insert / Update / Soft-Delete service items via UDT (Admin, new) ────────
// serviceList: [{ InternetConnectionMasterID, ServiceItem, InstallationCharges, action_id }]
export const insertUpdateInternetConnectionServiceItems_action = (serviceList) => async (dispatch) => {
    try {
        const params = {
            UserID:       JSON.parse(sessionStorage.getItem('loginDataSS')).UserID,
            ExhibitionID: sessionStorage.getItem('sessionExhibitionID'),
            serviceList,
        };
        const res = await axiosPost(insertUpdateInternetConnectionServiceItemsUrl, params, headers);
        dispatch({ type: INSERT_UPDATE_INTERNET_CONNECTION_SERVICE_ITEMS, payload: res });
        return Promise.resolve(res);
    } catch (error) {
        return Promise.reject(error);
    }
};
